import store from '../store/index'

const pages = import.meta.glob('../pages/**/*.vue')

function page (path) {
  const file = `../pages/${path.endsWith('.vue') ? path : `${path}.vue`}`

  if (!pages[file]) {
    throw new Error(`Page component not found: ${file}`)
  }

  return () => pages[file]().then(m => m.default || m)
}

export default [
  { path: '/', name: 'welcome', component: page('welcome.vue') },

  { path: '/login', name: 'login', component: page('auth/login.vue') },
  { path: '/register', name: 'register', component: page('auth/register.vue') },
  { path: '/password/reset', name: 'password.request', component: page('auth/password/email.vue') },
  { path: '/password/reset/:token', name: 'password.reset', component: page('auth/password/reset.vue') },
  { path: '/email/verify/:id', name: 'verification.verify', component: page('auth/verification/verify.vue') },
  { path: '/email/resend', name: 'verification.resend', component: page('auth/verification/resend.vue') },

  { path: '/home', name: 'home', component: page('home.vue') },
  { path: '/contact', name: 'contact', component: page('static/ContactPage.vue') },
  { path: '/paper-version', name: 'static.paper-version', component: page('static/PaperVersionPage.vue') },
  {
    path: '/survey-answer-set/:surveyAnswerSetId',
    component: page('surveyAnswerSets/SurveyAnswerSetTakeContainerPage'),
    props: route => ({ surveyAnswerSetId: route.params.surveyAnswerSetId }),
    children: [
      { path: '', name: 'surveyAnswerSet.start', component: page('surveyAnswerSets/SurveyAnswerSetStartPage.vue'), props: route => ({ surveyAnswerSetId: route.params.surveyAnswerSetId }) },
      { path: 'answer-question/:surveyQuestionId', name: 'surveyAnswerSet.question', component: page('surveyAnswerSets/SurveyAnswerSetQuestionPage.vue'), props: route => ({ surveyQuestionId: parseInt(route.params.surveyQuestionId), surveyAnswerSetId: route.params.surveyAnswerSetId }) },
      { path: 'results', name: 'surveyAnswerSet.results', component: page('surveyAnswerSets/SurveyAnswerSetResultsPage.vue'), props: route => ({ surveyAnswerSetId: route.params.surveyAnswerSetId }) },
      { path: 'results/:lang', name: 'surveyAnswerSet.resultsWithLang', component: page('surveyAnswerSets/SurveyAnswerSetResultsPage.vue'), props: route => ({ lang: route.params.lang, surveyAnswerSetId: route.params.surveyAnswerSetId }) }
    ]
  },
  {
    path: '/survey-results/:publicShareId/:lang?',
    name: 'surveyAnswerSet.publicResults',
    component: page('surveyAnswerSets/PublicSurveyResultsPage.vue'),
    props: route => ({ publicShareId: route.params.publicShareId })
  },
  // Static Contents
  { path: '/static-contents', name: 'staticContents.index', component: page('static-contents/StaticContentsIndexPage.vue') },
  {
    path: '/static-contents/:staticContentId',
    name: 'staticContents.edit',
    component: page('static-contents/StaticContentEditPage.vue'),
    props: route => ({ staticContentId: parseInt(route.params.staticContentId) })
  },
  {
    name: 'staticContents.show',
    path: '/pages/:slug',
    component: page('static-contents/StaticContentShowPage.vue'),
    props: route => ({ slug: route.params.slug })
  },
  {
    name: 'staticContents.showByIdentifier',
    path: '/static-content/:identifier',
    component: page('static-contents/StaticContentByIdentifierPage.vue'),
    beforeEnter: async function (to, from, next) {
      const staticContent = await store.dispatch('staticContents/staticContentByIdentifierAndLocale', { identifier: to.params.identifier, locale: store.getters['lang/locale'] })
      if (staticContent) {
        next({ name: 'staticContents.show', params: { slug: staticContent.slug } })
      } else {
        const staticContent = await store.dispatch('staticContents/staticContentByIdentifierAndLocale', { identifier: to.params.identifier, locale: 'en' })
        next({ name: 'staticContents.show', params: { slug: staticContent.slug } })
      }
    }
  },
  {
    path: '/settings',
    component: page('settings/index.vue'),
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: page('settings/profile.vue') },
      { path: 'password', name: 'settings.password', component: page('settings/password.vue') }
    ]
  },

  { path: '*', component: page('errors/404.vue') }
]
